import {
  AcademicCapIcon, BookOpenIcon, CalendarDaysIcon, ChartBarIcon, ClockIcon, FireIcon, GlobeAltIcon,
  HomeIcon,
  PlayIcon, PresentationChartLineIcon, QueueListIcon, Square3Stack3DIcon, ViewfinderCircleIcon,
} from '@heroicons/vue/24/outline';

// The v5 sidebar, grouped by pillar. `classic` is the current page a v5 placeholder links back to.
// `badge` is the small label after the name; `show` hides an item the classic sidebar also hides.
export const V5_NAV = [
  { items: [{ key: 'dashboard', icon: HomeIcon, classic: '/' }] },
  {
    group: 'play',
    items: [
      {
        key: 'matchmaking', icon: ViewfinderCircleIcon, classic: '/matchmaking', badge: 'beta', show: (u) => !!u.can_use_matchmaking,
      },
      { key: 'leaderboards', icon: ChartBarIcon, classic: '/leaderboards' },
    ],
  },
  {
    group: 'practice',
    items: [
      // Play Now: pick a mode and start a practice server
      { key: 'play', icon: PlayIcon, classic: '/play' },
      { key: 'routines', icon: ClockIcon, classic: '/routines' },
      { key: 'library', icon: Square3Stack3DIcon, classic: '/library' },
      { key: 'community_hub', icon: GlobeAltIcon, classic: '/community_hub/custom_sets' },
    ],
  },
  {
    group: 'analyze',
    items: [
      {
        key: 'coach', icon: PresentationChartLineIcon, classic: '/coach', badge: 'new',
      },
      {
        key: 'matches', icon: QueueListIcon, classic: '/matches', show: (u) => u.access_level >= 1,
      },
      {
        key: 'sessions', icon: CalendarDaysIcon, classic: '/sessions',
      },
    ],
  },
  {
    group: 'learn',
    items: [
      { key: 'academy', icon: BookOpenIcon, classic: '/academy' },
      { key: 'bootcamp', icon: AcademicCapIcon, classic: '/bootcamp' },
      { key: 'utility_hub', icon: FireIcon, classic: '/utility_hub' },
    ],
  },
];

export const V5_PAGES = V5_NAV.flatMap((g) => g.items);

export const v5Path = (key) => (key === 'dashboard' ? '/v5' : `/v5/${key}`);

export const classicFor = (key) => V5_PAGES.find((p) => p.key === key)?.classic || '/';

// A v5 page where one is built, else its classic page. The catch-all route matches anything,
// and a sidebar page not built yet has a placeholder route, so neither counts as built. Only the
// deepest record counts: the shell parent route matches every v5 page.
export function v5OrClassic(router, v5, classic) {
  const page = router.resolve(v5).matched.at(-1);
  return page && !page.path.includes('pathMatch') && !page.meta?.placeholder ? v5 : classic;
}
